module.exports = __webpack_public_path__ + "img/img8.749e27a4.jpg";